//Market security end points
var endPoints = {
    API_USER_NAME: "/Lookup/OktaUser",
    API_ABOUT_US: "/About",
    API_MARKET_RESEARCH: "/Publications",
    API_MARKET_RESEARCH_PUBLICATION: "/Publications/PublicationContent",
    API_DOCUMENT_NAME: "/documents",
    API_RATING: "/Ratings",
    API_ALERT: "/Alerts",
    API_MARKET_HISTORY: "/Markets/MarketGuideHistory",
    API_COUNTRY: "/Reports/CachedValidCountry",
    API_STATE: "/Reports/CachedValidState",
    API_Regions: "/Lookup/Regions",
    API_MarketType: "/Reports/CachedValidMarketType",
    API_ExcelBytesStream: "/Reports/ExportRecentChangesDataToExcelToStream",
    API_MARKET_ExcelBytesStream: "/Reports/ExportMarketDataToExcelDocObj",
    API_CLIENT_DROPDOWN: "/Client/Client",
    API_CLIENT_MARKET_AVAILABILITY: "/Client/ClientMarketAvailability",
    API_ADVANCE_MARKET_INFO: "/Reports/AdvanceMarketInfo",
    API_AMBEST_RATINGS: "/RatingsFinancials/AMBestRatings",
    API_AMBEST_RATINGS_VALUE: "/RatingsFinancials/lookup/AMBestRating",
    API_AMBEST_FINS: "/RatingsFinancials/AMBestFinancials",
    API_AMBEST_DETAILS: "/RatingsFinancials/AMBestRatingByMarketId",
    API_SANDP_DETAILS: "/RatingsFinancials/SandPRatingByMarketId",
    API_MARKET_FACT_SHEET: "/Reports/MarketFactSheets",
    API_SAND_PR_RATINGS: "/RatingsFinancials/SandPRatings",
    API_SAND_PR_RATINGS_VALUE: "/RatingsFinancials/lookup/SandPRating",
    API_MARKET_GUIDE: "/Markets/MarketGuide",
    API_CLIENT_STAFF_CONSTANTS: "/Client/ClientAccount",
    API_AON_STAFF_CONSTANTS: "/Client/ClientAssocaitedColleague",
    API_AON_STAFF_DROPDOWN: "/Client/SearchColleague",
    API_AON_STAFF_TYPES: "/Lookup/AssociatedColleagueTypes",
    API_AON_STAFF_CRUD: "/Client/addDeleteUpdateClientAssociatedColleague",
    API_CLIENT_STAFF_ADD: "/mprCreateRequests",
    API_MARKET_ADD_DELETE: "/Client/addDeleteClientMarket",
    API_SUBSCRIBED_ENTITIES: "/Entities/SubscribedEntitiesList",
    API_MARKET_FAVORITE: "/Entities/Favorites",
    API_MARKET_NEWS: "/Entities/News",
    API_MARKET_SUBSCRIPTIONS: "/Publications/MarketsWithSubscription",
    API_MARKET_TYPE_SPEC: "/Markets/MarketTypeSpecific",
    API_GROUP_PROFILE: "/Reports/GroupProfiles",
    API_MARKET_PROFILE: "/Reports/MarketProfiles",
    API_EMAIL_FACTSHEET: '/email/factSheets/okta',
    API_MARKET_INFO: '/Markets/MarketInfo',
    API_MARKET_GUIDE_STATUS: '/Markets/MarketGuideStatus',
    API_GET_ACKNOWLEDGEMENT: '/Eula/PendingAcknowledgements',
    API_POST_ACKNOWLEDGEMENT: '/Eula/CreateEulaAcknowledgement',
    API_MARKET_SECURITY_BRIEF: '/Markets/MarketSecurityBrief',
    API_SEND_CLIENT_REQUEST: "/Client/SendClientRequest"
};
export default endPoints;
